import React, { useEffect, useState } from "react";

import { getUrlSport, linkName } from "../../utils/generalLiveCenter";
import { loadStyles } from "../../utils/cssLoader";

const CricketPlayerInfo = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  websiteBaseUrl,
  dataPath,
  sport = "cricket",
}) => {
  const [clientData, setClientData] = useState(null);

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("cricketplayer");
    }
  }, [loadCSS]);

  const data = dataClient ? clientData : ServerData;
  console.log(data, 'data')
  const playerData = data?.data;

  if (!playerData) {
    return (
      <div className="cricket-player-info-card no-data">
        <p>{dictionary?.noPlayerInfo || "No player information available"}</p>
      </div>
    );
  }

  const { bplc, edu, teams } = playerData;

  const getTeamUrl = (team) => {
    if (!dataClient) return "#";
    const basePath = websiteBaseUrl || "";
    const pathSegment = dataPath || getUrlSport(sport);
    return `${basePath}/${pathSegment}/team/${linkName(team?.name)}/${team?.id}/info`;
  };

  return (
    <>
      {title && <h1>{title}</h1>}
      <div className="cricket-player-info-card">
        <div className="card-header">
          <div className="player-name-section">
            <h2 className="player-name">{dictionary?.overview || "Overview"}</h2>
          </div>
        </div>

        <div className="card-body">
          <div className="player-details-grid">
            {bplc && (
              <div className="detail-item">
                <span className="label">{dictionary?.birthplace || "Birthplace"}</span>
                <span className="value">{bplc}</span>
              </div>
            )}
            {edu && edu !== "-" && (
              <div className="detail-item">
                <span className="label">{dictionary?.education || "Education"}</span>
                <span className="value">{edu}</span>
              </div>
            )}
          </div>

          {teams && teams.length > 0 && (
            <div className="player-teams-section">
              <h3 className="section-title">{dictionary?.teamsRepresented || "Teams Represented"}</h3>
              <div className="teams-grid">
                {teams.map((team) => (
                  <a
                    key={team.id}
                    href={getTeamUrl(team)}
                    className="team-card"
                  >
                    <span className="team-name">{team.name}</span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CricketPlayerInfo;
